import { h } from 'preact'

/* eslint-disable max-len */

const GradeBacker = ({ fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill={fill}>
        <path
            d="M80,82a30,30,0,1,0,30,30A30,30,0,0,0,80,82Zm0,55a25,25,0,1,1,25-25A25,25,0,0,1,80,137Zm0-45a20,20,0,1,0,20,20A20,20,0,0,0,80,92Z"
            transform="translate(-50 -82)"
        />
    </svg>
)

GradeBacker.defaultProps = {
    fill: '#fff',
}

export default GradeBacker
